import { Web3OnboardProvider, init } from "@web3-onboard/react";
import { useEffect, useState, useMemo } from "react";
import { OnboardAPI } from "@web3-onboard/core";
import { isMobile } from "react-device-detect";
import walletConnectModule from "@web3-onboard/walletconnect";
import injectedModule from "@web3-onboard/injected-wallets";
import frameModule from "@web3-onboard/frame";
import ledgerModule from "@web3-onboard/ledger";
import trezorModule from "@web3-onboard/trezor";

type Web3OnboardWrapperProps = React.PropsWithChildren<object>;

const Web3OnboardWrapper = ({ children }: Web3OnboardWrapperProps) => {
  const [web3OnBoard, setWeb3OnBoard] = useState<OnboardAPI>();

  const wallets = useMemo(() => {
    const result = [];

    result.push(injectedModule(), walletConnectWallet(), ledgerWallet(), trezotWallet());

    if (!isMobile) {
      result.push(frameModule());
    }

    return result;
  }, []);

  useEffect(() => {
    const onboard = init({
      wallets,
      chains: [{ id: 1 }],
      appMetadata: {
        name: "inCoin",
        icon: "/img/incoin_logo_new.svg",
        description: "Pay with crypto",
        explore: (window as any).siteRootUrl
      },
      theme: "light",
      connect: {
        iDontHaveAWalletLink: (window as any).siteRootUrl + "/help"
      }
    });

    setWeb3OnBoard(onboard);
  }, [wallets]);

  if (!web3OnBoard) {
    return <></>;
  }

  return (
    <Web3OnboardProvider web3Onboard={web3OnBoard}>
      <div>{children}</div>
    </Web3OnboardProvider>
  );
};

const ledgerWallet = () => {
  const ledger = ledgerModule({
    walletConnectVersion: 2,
    /**
     * Project ID associated with [WalletConnect account](https://cloud.walletconnect.com)
     */
    projectId: "1a34a431abdb7606fe839f402af88300",
    /**
     * Chains required to be supported by all wallets connecting to your DApp
     */
    requiredChains: [1, 137]
  });

  return ledger;
};

const walletConnectWallet = () => {
  const wcV2InitOptions = {
    /**
     * Project ID associated with [WalletConnect account](https://cloud.walletconnect.com)
     */
    projectId: "1a34a431abdb7606fe839f402af88300",
    /**
     * Chains required to be supported by all wallets connecting to your DApp
     */
    requiredChains: [],
    /**
     * Defaults to `appMetadata.explore` that is supplied to the web3-onboard init
     * Strongly recommended to provide atleast one URL as it is required by some wallets (i.e. MetaMask)
     * To connect with WalletConnect
     */
    dappUrl: (window as any).siteRootUrl
  };

  return walletConnectModule(wcV2InitOptions);
};

const trezotWallet = () => {
  const trezor = trezorModule({
    email: "a@b.com",
    appUrl: (window as any).siteRootUrl
  });

  return trezor;
};

export default Web3OnboardWrapper;
